import React from 'react';
const DefaultItem = ({onClick, children, className, style, color}) => (
    <a href="javascript:;"  style={style}  onClick={onClick}><i className={className || "fa fa-list-alt fa-lg"} style={{color: color || '#b8bb08'}} aria-hidden="true"></i>{children}</a>
    );
    

export default DefaultItem;